export interface PlanPeriod {
  policies: number
  period: number
}

function parsePlanPeriod(duration: string): PlanPeriod | undefined {
  if (!duration) return undefined

  let policies = 1
  let period = duration

  if (duration.includes('x')) {
    const durationValues = duration.split('x')
    policies = +durationValues[0]
    period = durationValues[1]
  } else if (duration.includes('+')) {
    const durationValues = duration.split('+')
    period = durationValues[0]
    policies = 2
  }

  return { policies, period: +period }
}

export default parsePlanPeriod
